import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from './locales/en/common.json';
import authEN from './locales/en/auth.json';
import dashboardEN from './locales/en/dashboard.json';
import shopEN from './locales/en/shop.json';
import trainingEN from './locales/en/training.json';
import chatEN from './locales/en/chat.json';
import formsEN from './locales/en/forms.json';
import exercisesEN from './locales/en/exercises.json';
import trainerProfileEN from './locales/en/trainerProfile.json';
import adminEN from './locales/en/admin.json';
import guideEN from './locales/en/guide.json';
import blogEN from './locales/en/blog.json';
import nutritionEN from './locales/en/nutrition.json';

import commonHR from './locales/hr/common.json';
import authHR from './locales/hr/auth.json';
import dashboardHR from './locales/hr/dashboard.json';
import shopHR from './locales/hr/shop.json';
import trainingHR from './locales/hr/training.json';
import chatHR from './locales/hr/chat.json';
import formsHR from './locales/hr/forms.json';
import exercisesHR from './locales/hr/exercises.json';
import trainerProfileHR from './locales/hr/trainerProfile.json';
import adminHR from './locales/hr/admin.json';
import guideHR from './locales/hr/guide.json';
import blogHR from './locales/hr/blog.json';
import nutritionHR from './locales/hr/nutrition.json';

// German translations
import commonDE from './locales/de/common.json';
import authDE from './locales/de/auth.json';
import dashboardDE from './locales/de/dashboard.json';
import shopDE from './locales/de/shop.json';
import trainingDE from './locales/de/training.json';
import chatDE from './locales/de/chat.json';
import formsDE from './locales/de/forms.json';
import exercisesDE from './locales/de/exercises.json';
import trainerProfileDE from './locales/de/trainerProfile.json';
import adminDE from './locales/de/admin.json';
import guideDE from './locales/de/guide.json';
import blogDE from './locales/de/blog.json';
import nutritionDE from './locales/de/nutrition.json';

const resources = {
  en: {
    common: commonEN,
    auth: authEN,
    dashboard: dashboardEN,
    shop: shopEN,
    training: trainingEN,
    chat: chatEN,
    forms: formsEN,
    exercises: exercisesEN,
    trainerProfile: trainerProfileEN,
    admin: adminEN,
    guide: guideEN,
    blog: blogEN,
    nutrition: nutritionEN
  },
  hr: {
    common: commonHR,
    auth: authHR,
    dashboard: dashboardHR,
    shop: shopHR,
    training: trainingHR,
    chat: chatHR,
    forms: formsHR,
    exercises: exercisesHR,
    trainerProfile: trainerProfileHR,
    admin: adminHR,
    guide: guideHR,
    blog: blogHR,
    nutrition: nutritionHR
  },
  de: {
    common: commonDE,
    auth: authDE,
    dashboard: dashboardDE,
    shop: shopDE,
    training: trainingDE,
    chat: chatDE,
    forms: formsDE,
    exercises: exercisesDE,
    trainerProfile: trainerProfileDE,
    admin: adminDE,
    guide: guideDE,
    blog: blogDE,
    nutrition: nutritionDE
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'hr', // Default to Croatian for Bosnia and Herzegovina/Croatia
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'shop', 'training', 'chat', 'forms', 'exercises', 'trainerProfile', 'admin', 'guide', 'blog', 'nutrition'],
    interpolation: {
      escapeValue: false // React already escapes
    },
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    react: {
      useSuspense: false // Avoid suspense issues
    }
  });

export default i18n;

